import React from 'react'
import HighchartsReact from 'highcharts-react-official'
import Highcharts from 'highcharts'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import I18n from 'i18n'
import { buildChartOptions, buildPoints } from './researchDashboardChartHelpers'
import { MetricData } from '../../../../common/types/ResearchDashboardMetricsDTO'

interface Props {
  title: string
  data: MetricData | null | undefined
  color: string
  isLoading: boolean
  offset: number
  onOffsetChange: (offset: number) => void
  periodToggle?: React.ReactNode
  currentWeekLabel?: string
}

export default function ComplianceChart ({
  title,
  data,
  color,
  isLoading,
  offset,
  onOffsetChange,
  periodToggle,
  currentWeekLabel
}: Props): React.ReactElement {
  const chartData = buildPoints(data ?? null)

  const canNavigateToPresent = offset > 0

  return (
    <div className='rd-graph-section'>
      <div className='rd-graph-header'>
        <h3 className='rd-graph-title'>
          {title}
        </h3>
        {periodToggle}
      </div>

      <div className='rd-chart-wrapper'>
        {isLoading
          ? (
            <div style={{ height: 350, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {I18n.t('components.dashboards.research_dashboard.charts.loading')}
            </div>
            )
          : (
            <HighchartsReact
              highcharts={Highcharts}
              options={buildChartOptions(chartData, color, currentWeekLabel)}
            />
            )}
        <div className='rd-chart-navigation'>
          <button
            className='rd-nav-btn'
            onClick={() => onOffsetChange(offset + 1)}
            disabled={isLoading}
            title={I18n.t('components.dashboards.research_dashboard.charts.previous_period')}
          >
            <FontAwesomeIcon icon='chevron-left' />
          </button>
          <button
            className='rd-nav-btn'
            onClick={() => onOffsetChange(Math.max(0, offset - 1))}
            disabled={!canNavigateToPresent || isLoading}
            title={I18n.t('components.dashboards.research_dashboard.charts.next_period')}
          >
            <FontAwesomeIcon icon='chevron-right' />
          </button>
        </div>
      </div>
    </div>
  )
}
